<!-- Step 1: Registration -->
<div *ngIf="step === 1" class="step-container">
  <h2>{{ 'registration.register_title' | translate }}</h2>
  <form [formGroup]="form">

    <app-input
      style="flex: 1;"
      formControlName="firstname"
      [withNoIcon]="true"
      [state]="InputState.REGULAR"
      [placeholder]="'registration.first_name' | translate"
      [size]="InputSize.LARGER"
    ></app-input>

    <app-input
      style="flex: 1;"
      formControlName="lastname"
      [withNoIcon]="true"
      [placeholder]="'registration.last_name' | translate"
      [size]="InputSize.LARGER"
      [state]="InputState.REGULAR"
    ></app-input>

    <app-input
      [leftIcon]="'Mail'"
      [placeholder]="'registration.email_placeholder' | translate"
      [showLabel]="true"
      [showLeftIcon]="true"
      [size]="InputSize.LARGER"
      [state]="InputState.REGULAR"
      formControlName="email"
    ></app-input>

    <mat-error>
      <div *ngIf="isInvalidAndTouched('email')" class="error-message">
        <span *ngIf="form.get('email')?.errors?.['required']">{{ 'errors.email_required' | translate }}</span>
        <span *ngIf="form.get('email')?.errors?.['email']">{{ 'errors.email_valid' | translate }}</span>
      </div>
    </mat-error>

    <app-input
      formControlName="password"
      [leftIcon]="'Lock'"
      [type]="'password'"
      [placeholder]="'registration.password_placeholder' | translate"
      [rightIcon]="'Eye'"
      [showLabel]="true"
      [showLeftIcon]="true"
      [showRightIcon]="false"
      [size]="InputSize.LARGER"
      [state]="InputState.FILLED"
    ></app-input>

    <app-button
      [label]="'registration.continue' | translate"
      [type]="ButtonType.PRIMARY"
      [size]="ButtonSize.LARGE"
      [state]="form.invalid ? ButtonState.DISABLED : ButtonState.REGULAR"
      (click)="onSubmitRegistration()"
    ></app-button>
  </form>
</div>

<!-- Step 2: CV Upload -->
<div *ngIf="step === 2" class="modal-container">
  <h2>{{ 'registration.add_new_candidate' | translate }}</h2>
  <p class="subtitle">{{ 'registration.subtitle' | translate }}</p>

  <label class="section-label">{{ 'registration.upload_cv' | translate }}</label>

  <div class="upload-box">
    <div class="upload-placeholder">
      <app-upload-form
        [materialType]="MaterialType.CV"
        [userId]="userId"
        (uploaded)="sendUploadedFile($event)"
      ></app-upload-form>
    </div>
  </div>

  <p class="accepted-formats">{{ 'registration.accepted_formats' | translate }}</p>

  <button class="manual-entry-btn" (click)="onManualEntry()">
    {{ 'registration.manual_entry' | translate }}
  </button>
</div>
